module.exports = __webpack_public_path__ + "img/305.67defac5.jpg";